import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Homepage from './Components/Homepage';
import Categories from './Components/Categories';
import Contact from './Components/Contact';
import Playquiz from './Components/Playquiz';
import Quizgame from './Components/Quizgame';
import Result from './Components/Result';
import Aboutus from './Components/Aboutus';
import Start from './Components/Start';
import Privacy from './Components/Privacy';
import Contestrule from './Components/Contestrule';
import Terms from './Components/Terms';
import { useEffect } from 'react';
import ReactGA from "react-ga4";

function App() {
   const location = useLocation();
   useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);
  return (
    <>
   
    <Routes>
       <Route path="/" element={<Homepage/>}/>
       <Route path="/about" element={<Aboutus/>}/>
       <Route path="/category" element={<Categories/>}/>
       <Route path="/category/:name" element={<Playquiz />} />
       <Route path="/contact" element={<Contact/>}/>
       <Route path="/quiz/:name" element={<Quizgame />} />
       <Route path="/result" element={<Result />} />
       <Route path='/start' element={<Start />} />
       <Route path='/privacy' element={<Privacy />} />
       <Route path='/terms' element={<Terms />} />
       <Route path='/rule' element={<Contestrule />} />
    </Routes>
       
    </>
  );
}

export default App;
